"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListItem = function DefaultListItem(_ref) {
  var currentClass = _ref.currentClass,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: currentClass
  }, /*#__PURE__*/_react["default"].createElement("p", null, children));
};

ListItem.propTypes = {
  children: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  currentClass: _propTypes["default"].string.isRequired
};
var _default = ListItem;
exports["default"] = _default;